import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

import type { SourcedocumentDataSchemaFor } from "./_gmw-event-schema-collection";

export const gmwLengtheningSchema: SourcedocumentDataSchemaFor<"GMW_Lengthening"> = {
  type: "object",
  title: "Gebeurtenis gegevens",
  required: ["eventDate", "monitoringTubes"],
  properties: {
    ...pickGmwLibraryFields(["eventDate", "wellHeadProtector"]),
    monitoringTubes: {
      type: "array",
      title: "Monitoringsbuis",
      minItems: 1,
      items: {
        type: "object",
        required: [
          "tubeNumber",
          "variableDiameter",
          "tubeTopDiameter",
          "tubeTopPosition",
          "tubeTopPositioningMethod",
          "tubeMaterial",
          "glue",
          "plainTubePartLength",
        ],
        properties: pickGmwLibraryFields([
          "tubeNumber",
          "variableDiameter",
          "tubeTopDiameter",
          "tubeTopPosition",
          "tubeTopPositioningMethod",
          "tubeMaterial",
          "glue",
          "plainTubePartLength",
        ]),
      },
    },
  },
};
